import {BsChat, BsShop} from "react-icons/bs"
import {MdOutlineSwapHorizontalCircle} from "react-icons/md"
import {IoNotificationsOutline, IoSettingsOutline} from "react-icons/io5"
import {CgProfile} from "react-icons/cg";
import {MdLogout} from "react-icons/md";
import NavStyle from "../styles/ProfileNav.module.css";
import { useRouter } from "next/router";
import {signOut} from "next-auth/react"

export default function Home({children, size}) {

    const router = useRouter();

    return (
      <div className={`grid grid-cols-[80px_1fr]`} style={{ height: "calc(100vh - 130px)" }}>
        <div
          className={`bg-primary text-white text-2xl ${NavStyle.parentSidebar} py-10 z-20 flex items-center flex-col justify-between align-middle px-3 h-full hover:overflow-y-auto overflow-x-hidden`}
        >
          <div className={`flex items-center flex-col`}>
            <div
              className={`hover:text-yellow hover:cursor-pointer ${
                router.pathname == "/profile/chats"
                  ? "text-yellow cursor-pointer"
                  : ""
              }`}
              onClick={() => {
                router.push("/profile/chats");
              }}
            >
              <BsChat />
              <span>Chat</span>
            </div>
            <div
              className={`hover:text-yellow hover:cursor-pointer ${
                router.pathname == "/profile/offers"
                  ? "text-yellow cursor-pointer"
                  : ""
              }`}
              onClick={() => {
                router.push("/profile/offers");
              }}
            >
              <MdOutlineSwapHorizontalCircle /> <span>Offers</span>
            </div>
            <div
              className={`hover:text-yellow hover:cursor-pointer ${
                router.pathname == "/profile/notifications"
                  ? "text-yellow cursor-pointer"
                  : ""
              }`}
              onClick={() => {
                router.push("/profile/notifications");
              }}
            >
              <IoNotificationsOutline />
              <span>Notifications</span>
            </div>
            <div
              className={`hover:text-yellow hover:cursor-pointer ${
                router.pathname == "/profile/aunctions"
                  ? "text-yellow cursor-pointer"
                  : ""
              }`}
              onClick={() => {
                router.push("/profile/aunctions");
              }}
            >
              <BsShop />
              <span>Aunctions</span>
            </div>
            <div
              className={`hover:text-yellow hover:cursor-pointer ${
                router.pathname == "/profile/settings"
                  ? "text-yellow cursor-pointer"
                  : ""
              }`}
              onClick={() => {
                router.push("/profile/settings");
              }}
            >
              <IoSettingsOutline />
              <span>Settings</span>
            </div>
          </div>

          <div className={`flex items-center flex-col`}>
            <div
              className="hover:text-yellow hover:cursor-pointer"
              onClick={() => {
                router.push("/profile");
              }}
            >
              <CgProfile />
              <span>Profile</span>
            </div>
            <div className="hover:text-yellow hover:cursor-pointer">
              <MdLogout />
              <span>Log Out</span>
            </div>
          </div>
        </div>
        <div className="overflow-y-hidden h-full">{children}</div>
      </div>
    );
}

